import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AdsHeaderComp from "src/components/ads/adsHeaderComp";
import AdsTableParent from "src/components/ads/adsTableParent";
import {
	useAppDispatch,
	useAppSelector,
	setAds,
	setPagination,
	setCurrentPage,
	setAdsLoading,
	setAdsError,
	setSelectedAdType,
	useLazyGetAllAdsQuery,
} from "src/store";

const AdsCategory = () => {
	const dispatch = useAppDispatch();
	const [searchParams] = useSearchParams();
	const adType = searchParams.get("type") || "";

	const { ads, pagination, currentPage, loading } = useAppSelector(
		(state) => state.ads
	);
	const [getAllAds] = useLazyGetAllAdsQuery();

	const fetchAds = async () => {
		dispatch(setAdsLoading(true));
		dispatch(setAdsError(null));

		try {
			const result = await getAllAds({ page: currentPage, adType, limit: 1 }).unwrap();
			dispatch(setAds(result.payload.data));
			dispatch(setPagination(result.payload.pagination));
		} catch (error: any) {
			const errorMessage = error?.data?.error?.message || "Failed to fetch ads";
			dispatch(setAdsError(errorMessage));
			console.error(error);
		} finally {
			dispatch(setAdsLoading(false));
		}
	};

	useEffect(() => {
		dispatch(setSelectedAdType(adType));
		fetchAds();
	}, [adType, currentPage, dispatch, getAllAds]);
	const handlePageChange = (page: number | ((prevState: number) => number)) => {
		const newPage = typeof page === "function" ? page(currentPage) : page;
		dispatch(setCurrentPage(newPage));
	};

	return (
		<div>
			<AdsHeaderComp type={adType} callback={fetchAds} />
			<AdsTableParent
				type={adType}
				ads={ads}
				isLoading={loading}
				pageNo={currentPage}
				paginationData={pagination}
				setPageNo={handlePageChange}
				callback={fetchAds}
			/>
			<ToastContainer />
		</div>
	);
};

export default AdsCategory;
